import { render } from "./TruckCoverComponent.vue?vue&type=template&id=145f5c00&scoped=true"
import script from "./TruckCoverComponent.vue?vue&type=script&lang=js"
export * from "./TruckCoverComponent.vue?vue&type=script&lang=js"

import "./TruckCoverComponent.vue?vue&type=style&index=0&id=145f5c00&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145f5c00"]])

export default __exports__